import { useEffect, useState } from "react";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";
import { useApiCall } from "../custom-hooks/api-call";
import { Link } from "react-router";
import { ChartMainCard } from "./ChartsHeader";
import { TeamAvailability } from "./StatCardIcons";

const leads = [
  {
    id: 1,
    leadName: "Collins",
    company: "BrightWave Innovations",
    companyLogo: "🚀",
    stage: "Contacted",
    stageColor: "bg-blue-100 text-blue-700",
    date: "14/01/2024",
    owner: "Hendry",
  },
  {
    id: 2,
    leadName: "Konopelski",
    company: "Stellar Dynamics",
    companyLogo: "⭐",
    stage: "Closed",
    stageColor: "bg-green-100 text-green-700",
    date: "21/01/2024",
    owner: "Guilory",
  },
  {
    id: 3,
    leadName: "Adams",
    company: "Quantum Nexus",
    companyLogo: "⚛️",
    stage: "Lost",
    stageColor: "bg-red-100 text-red-700",
    date: "20/02/2024",
    owner: "Jami",
  },
  {
    id: 4,
    leadName: "Schumm",
    company: "EcoVision Enterprises",
    companyLogo: "🌿",
    stage: "Not Contacted",
    stageColor: "bg-purple-100 text-purple-700",
    date: "15/03/2024",
    owner: "Theresa",
  },
  {
    id: 5,
    leadName: "Wisozk",
    company: "Aurora Technologies",
    companyLogo: "🌅",
    stage: "Closed",
    stageColor: "bg-green-100 text-green-700",
    date: "12/04/2024",
    owner: "Smith",
  },
];

export function RecentLeadsTable({ view }) {
  const [recentLeads, setRecentLeads] = useState([]);
  const [recentLoading, setRecentLoading] = useState(false);
  const apiCall = useApiCall();

  const getRecentLeads = async () => {
    setRecentLoading(false);

    const apiUrl = `leads/get-leads?view=${view}`;

    try {
      const res = await apiCall({ method: "get", url: apiUrl });

      const top10 = Array.isArray(res?.data)
        ? res.data.slice(0, 10) // first 10 items
        : [];

      setRecentLeads(top10);
    } catch (error) {
      console.warn("Error fetching brand data:", error);
    } finally {
      setRecentLoading(true);
    }
  };

  useEffect(() => {
    getRecentLeads();
  }, []);

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      // iconColor={'bg-theme-purple-light text-theme-purple'}
      iconColor={"bg-[#FEE2E2] text-[#FF4040]"}
      heading="Latest Lead Entries"
      subHeading={"Most recent prospects captured"}
    >
      {recentLoading ? (
        <div className="max-h-[430px] min-h-[430px] overflow-auto">
          {recentLeads.length > 0 ? (
            <table className="min-w-full">
              <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Lead Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Value ($)
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Source
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Created Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Probability (%)
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">

                {recentLeads.map((lead) => (
                  <tr key={lead.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <h6 className="font-semibold text-sm">
                        {lead?.name?.trim() ? lead.name : "-"}
                      </h6>
                    </td>
                    <td className="px-6 py-4">
                      <h6 className="font-medium text-sm">
                        {lead["estimated_value($)"]
                          ? lead["estimated_value($)"]
                          : "-"}
                      </h6>
                    </td>
                    <td className="px-6 py-4">{lead?.source ?? "-"}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {lead?.date_created.trim() ? lead?.date_created : "-"}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {lead["probability(%)"]
                        ? `${lead["probability(%)"]}`
                        : "-"}
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>

          ) : (
            <DataNotFound title={"Leads"} />
          )}
        </div>
      ) : (
        <InnerLoader />
      )}
    </ChartMainCard>
  );
}
